module.exports = __webpack_public_path__ + "img/bad-session-1.96b57d69.png";